import { useCurrentUser } from '../../../../../modules/context/UserContext'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import { n_silcon, s_aug_promo } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import ChallengeStampBoard from './ChallengeStampBoard'
import Progressbar from './Progressbar'

const DURATION = {
  FORTY: 40,
  TWENTY: 20,
} as const

type Duration = (typeof DURATION)[keyof typeof DURATION]

const MyChallengeStatus = ({ selectedDuration, setSelectedDuration, challengeInfo, challengeProgress }) => {
  const isMobile = useIsMobile()
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  return (
    <section className="max-h-[681px] overflow-hidden px-20 sm:px-0 py-80 flex flex-col items-center bg-gray-50">
      {!currentUser && (
        <div className="mb-40 py-12 px-8 sm:w-[830px] bg-purple-50 rounded-[8px] text-center">
          <span className="Title1-20Bd text-purple-500">{t(n_silcon.log_in_needed)}</span>
        </div>
      )}
      <h2 className="Hero4-32Bd sm:Hero2-48Bd">{t(n_silcon.board_title)}</h2>
      <section className="mt-32 w-[190px] min-h-42 flex items-center bg-white border-[1.5px] border-gray-200 rounded">
        <button
          className={`w-1/2 h-42 px-4 rounded-l transition-all duration-300 ${
            selectedDuration === DURATION.FORTY
              ? 'bg-[#EEEBFA] Body1-16Bd text-purple-500 border-r-[1.5px]'
              : 'Body1-16Md'
          }`}
          onClick={() => setSelectedDuration(DURATION.FORTY)}
        >
          {DURATION.FORTY}
          {t(s_aug_promo.section_timer.min)}
        </button>
        <button
          className={`w-1/2 h-42 px-4 rounded-r transition-all duration-300 ${
            selectedDuration === DURATION.TWENTY
              ? 'bg-[#EEEBFA] Body1-16Bd text-purple-500 border-l-[1.5px]'
              : 'Body1-16Md'
          }`}
          onClick={() => setSelectedDuration(DURATION.TWENTY)}
        >
          {DURATION.TWENTY}
          {t(s_aug_promo.section_timer.min)}
        </button>
      </section>

      <section className="mt-24 mb-16 p-24 pb-32 w-full sm:w-[830px] flex flex-col gap-y-20 bg-white border rounded-lg">
        <div className="flex flex-col gap-y-8">
          <div className="flex justify-between">
            <span className="Body1-16Md sm:Title1-20Md">{t(n_silcon.board_period)}</span>
            <span className="Body1-16Md sm:Title1-20Md text-gray-500">
              {t(n_silcon.board_period_number(challengeInfo.remainingDays))}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="Body1-16Md sm:Title1-20Md">{t(n_silcon.board_progress)}</span>
            <div>
              <span className="Body1-16Md sm:Title1-20Md text-purple-500">
                {t(n_silcon.board_progress_s(challengeProgress.completedCount))}
              </span>
              <span className="Body1-16Md sm:Title1-20Md text-gray-500">
                / {t(n_silcon.board_progress_t(challengeProgress.totalTargetCount))}
              </span>
            </div>
          </div>
        </div>
        <Progressbar progress={challengeProgress.achievementRate} width={isMobile ? '90%' : '96%'} />
      </section>

      <ChallengeStampBoard duration={selectedDuration} completedDates={challengeProgress.stamps} />

      {/* <h3 className="mt-48 Headline2-24Bd text-center">{t(n_silcon.add_mission_t)}</h3>
      <MissionSlide missions={challengeProgress.missions} targetCount={challengeProgress.monthlyMissionTargetCount} /> */}
    </section>
  )
}

export default MyChallengeStatus
